import { cx } from '@emotion/css'
import React, { forwardRef, type ReactNode, type Ref } from 'react'

import type { RestrictedContainerProps } from '../../types'
import { CssVars } from '../themes'
import { InternalElevate } from './internal/InternalElevate'
import { useTheme } from './ThemeProvider'

type Props = {
  type?: 'primary' | 'secondary'
  className?: string
  children: ReactNode
} & RestrictedContainerProps

export const Card = forwardRef(function _Card(
  { children, className, type = 'primary', ...containerProps }: Props,
  ref: Ref<HTMLDivElement>
) {
  const theme = useTheme()
  return (
    <InternalElevate amount={type === 'primary' ? 1 : 0}>
      {({ rootClassName }) => (
        <div
          {...containerProps}
          ref={ref}
          className={cx(rootClassName, className)}
          css={[
            {
              backgroundColor: CssVars.neutral.bg1,
              border: `1px solid ${CssVars.neutral.bg3}`,
              borderRadius: CssVars.size.borderRadius,
              boxSizing: 'border-box',
            },

            type === 'primary' &&
              !theme.isDark && {
                boxShadow: `
                    0px -12px 24px ${CssVars.shadow.s2},
                    0px 12px 24px ${CssVars.shadow.s1}`,
              },
          ]}
        >
          {children}
        </div>
      )}
    </InternalElevate>
  )
})
